import React, { useState } from "react";
import { createContext } from "react";
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut } from "firebase/auth";
import app from "./../../firebase/firebase.config";
import { useEffect } from "react";

export const AuthContext = createContext();

const auth = getAuth(app);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

const providerLogin = (provider) =>{
    setLoading(true);
    return signInWithPopup(auth, provider)
}

const createUser = (email,password) =>{
    setLoading(true);
    return createUserWithEmailAndPassword(auth, email,password);
}

const signin =(email,password)=>{
    setLoading(true);

    return signInWithEmailAndPassword(auth, email,password);
}

const logOut =() =>{
    setLoading(true);
    return signOut(auth);
}

useEffect( () =>{
const unsubscribe = onAuthStateChanged(auth, currentUser =>{
    console.log(currentUser)
    setUser(currentUser)
    setLoading(false);
})
return () =>{
    unsubscribe()
}
}, [])
  const authInfo = {
    user,
    providerLogin,
    loading,
    createUser,
    signin,
logOut,
loading
  };
  console.log(user)
  return (
    <AuthContext.Provider value={authInfo}>
        {children}
        </AuthContext.Provider>
  );
};

export default AuthProvider;
